module.exports = __webpack_public_path__ + "img/level3addon_idle_gun_shadow.199111dd.png";